<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'IconDropdown',
  props: {
    color: {
      type: String,
      default: '#999BA3',
    },
  },
});
</script>

<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.5 5.5L7.78846 11.5L13.5 5.5"
      :stroke="color"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
